// extracted by mini-css-extract-plugin
module.exports = {"loadingText":"editor_loadingText__QQbZN"};